const menuBreakpoint = '1000px';

export default menuBreakpoint;